import { render, staticRenderFns } from "./LicitacaoAtualizacaoAcoesDocumentos.vue?vue&type=template&id=51bfdd30"
import script from "./LicitacaoAtualizacaoAcoesDocumentos.vue?vue&type=script&lang=js"
export * from "./LicitacaoAtualizacaoAcoesDocumentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports